export default __webpack_public_path__ + "reload.mp3";